import Vue from 'vue'

/**
  Para usar, basta chamar a propriedade e passar um

  Exemplo: <h1> {{dadoNumérico  }} </h1>
  Na View, ele transforma em Euro.
 **/
// Vue.filter('currency', value => {
// 	if (typeof value !== "number") {
// 			return value;
// 	}
// 	const formatter = new Intl.NumberFormat('de-DE', {
// 			style: 'currency',
// 			currency: 'EUR',
// 			minimumFractionDigits: 2
// 	});
// 	return formatter.format(value);
// });

Vue.filter('currency', (value, returnNumber, returnWithMark) => {
  if (typeof value !== "number") {
    return value;
  }

  function formatNumberWithoutRounding(number) {
    let numStr = number.toString();
    let decimalIndex = numStr.indexOf('.');

    if (decimalIndex === -1) {
      return numStr + ".00";
    }

    let integerPart = numStr.substring(0, decimalIndex);
    let decimalPart = numStr.substring(decimalIndex + 1);

    if (decimalPart.length < 2) {
      decimalPart += "0".repeat(2 - decimalPart.length);
    }

    decimalPart = decimalPart.substring(0, 2);

    return integerPart + '.' + decimalPart;
  }

  // const formattedNumber = formatNumberWithoutRounding(value);
  const formattedNumber = +value.toFixed(2);
  const formatterStringWithComma = String(formattedNumber).replace('.', ',');

  if (returnNumber) {
    const formatterNumber = parseFloat(formattedNumber);

    if (!returnWithMark) {
      return formatterNumber;
    } else {
      return `${formatterNumber} €`;
    }
  }

  return formatterStringWithComma + " €";
});




// export const formatEuroValues = (value: any, returnNumber?: boolean, returnWithMark?: boolean) => {
//   const formatWith2Digits = +value.toFixed(2);
//   const formatterWithEuroMark = String(formatWith2Digits) + " €";
//   const formatterStringWithoutEuroMark = String(formatWith2Digits);
//   const formatterNumberWithoutEuroMark = +formatWith2Digits;

//   if (returnNumber) {
//       if(!returnWithMark) {
//         let numericValue = parseFloat(formatterStringWithoutEuroMark.replace(',', '.'));
//         return numericValue;
//       } else {
//         return formatterNumberWithoutEuroMark;
//       }
//   }
//   return formatterWithEuroMark;
// }
